import { Fragment, useContext, useState } from "react"
import { menuRoutes } from "../../../router/menu";
import { PrivilegeContext } from "../../../components/priviledge/PriviledgeProvider";
import { useNavigate } from "react-router-dom";
import { FiltersProvider } from "../../../components/providers/FiltersProvider";
import cn from "../../../utils/classNames";
import { Button } from "rizzui";
import PageHeader from "../../../layout/shared/page-header";
import ConfigList from "./ConfigList";


const ConfigListWrapper = () => {

    // STATES

    const [openFormDrawer, setOpenFormDrawer] = useState<boolean>(false);
    const [configSelected, setConfigSelected] = useState<any | null>(null);


    const breadCrumb = [
        { name: 'Administración' },
        { name: 'Clientes', href: menuRoutes.clients.path }
    ];

    // HOOKS

    const { userCan } = useContext(PrivilegeContext)
    const navigate = useNavigate();

    // RENDER

    return (
        <Fragment>
            <FiltersProvider>
                <PageHeader title="Listado de configuraciones" breadcrumb={breadCrumb}>
                    {
                        userCan('create', 'config') &&
                        (
                            <Button
                                color="primary"
                                onClick={() => {
                                    setOpenFormDrawer(true);
                                    setConfigSelected(null);
                                }}
                                className={cn(['mt-4 md:mt-0'])}
                            >
                                Crear configuración
                            </Button>
                        )
                    }
                </PageHeader>
                <ConfigList openFormDrawer={openFormDrawer} setOpenFormDrawer={setOpenFormDrawer} configSelected={configSelected} setConfigSelected={setConfigSelected} />
            </FiltersProvider>
        </Fragment>
    )
}

export default ConfigListWrapper;